/**
 * SEO landing paths for common Google queries (e.g. "pvc susp tds pdf").
 * Each path renders TdsPage with a preset catalog search.
 */

export const TDS_KEYWORD_LANDINGS = [
  {
    path: '/pvc-susp-tds-pdf',
    search: 'PVC Susp',
    title: 'PVC Suspension TDS PDF Download | BSB Fortrade',
    description:
      'Download PVC suspension polymer Technical Data Sheets (TDS) PDF. Browse SG5 and other PVC Susp grades from BSB Fortrade.',
    keywords: 'pvc susp tds pdf, pvc suspension tds, sg5 tds pdf, pvc polymer tds',
  },
  {
    path: '/pvc-pipe-tds-pdf',
    search: 'PVC Pipe',
    title: 'PVC Pipe Grade TDS PDF Download | BSB Fortrade',
    description: 'PVC pipe grade polymer TDS PDF library. View and download technical data sheets from BSB Fortrade.',
    keywords: 'pvc pipe tds pdf, pvc pipe grade tds, polymer tds pdf',
  },
  {
    path: '/pp-injection-tds-pdf',
    search: 'PP Inj',
    title: 'PP Injection Moulding TDS PDF | BSB Fortrade',
    description: 'PP injection moulding polymer TDS PDF downloads. Prime PP grades with MFI and specifications.',
    keywords: 'pp injection tds pdf, pp inj tds, polypropylene tds pdf',
  },
  {
    path: '/pp-raffia-tds-pdf',
    search: 'PP Raffia',
    title: 'PP Raffia TDS PDF Download | BSB Fortrade',
    description: 'PP raffia grade TDS PDF for woven sacks and raffia applications. BSB Fortrade polymer TDS library.',
    keywords: 'pp raffia tds pdf, polypropylene raffia tds',
  },
  {
    path: '/hdpe-blow-tds-pdf',
    search: 'HDPE Blow',
    title: 'HDPE Blow Moulding TDS PDF | BSB Fortrade',
    description: 'HDPE blow moulding TDS PDF downloads. Technical data sheets for bottles and blow moulded parts.',
    keywords: 'hdpe blow tds pdf, hdpe blow moulding tds',
  },
  {
    path: '/hdpe-film-tds-pdf',
    search: 'HDPE Film',
    title: 'HDPE Film Grade TDS PDF | BSB Fortrade',
    description: 'HDPE film grade polymer TDS PDF. Download specifications from BSB Fortrade.',
    keywords: 'hdpe film tds pdf, hdpe polymer tds',
  },
  {
    path: '/lldpe-film-tds-pdf',
    search: 'LLDPE Film',
    title: 'LLDPE Film TDS PDF Download | BSB Fortrade',
    description: 'LLDPE film grade TDS PDF library. View and download polymer technical data sheets.',
    keywords: 'lldpe film tds pdf, lldpe tds download',
  },
  {
    path: '/ldpe-film-tds-pdf',
    search: 'LDPE Film',
    title: 'LDPE Film TDS PDF Download | BSB Fortrade',
    description: 'LDPE film polymer TDS PDF. Browse grades and download TDS from BSB Fortrade India.',
    keywords: 'ldpe film tds pdf, ldpe polymer tds',
  },
];

export const TDS_KEYWORD_PATHS = TDS_KEYWORD_LANDINGS.map((l) => l.path);

export const getTdsKeywordLanding = (pathname) =>
  TDS_KEYWORD_LANDINGS.find((l) => l.path === pathname) || null;
